import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { bumpIn } from '../../../styles/animations';

// Доступные классы кнопки
type buttonClass =
  | 'big-gray-light'
  | 'big-purple-gradient'
  | 'small-purple-gradient'
  | 'big-red-gradient'
  | 'big-dark-charcoal-gradient'
  | 'big-light-gray'
  | 'small-light-gray'
  | 'big-gray'
  | 'big-raisin-black'
  | 'small-raisin-black'
  | 'small-gray'
  | 'only-icon-light-gray'
  | 'only-icon-dark-gray'
  | 'only-icon-light-gray-sm'
  | 'only-icon-red'
  | 'small-reset'
  | 'big-transparent'
  | 'big-white'
  | 'big-white-text-orange'
  | 'small-white'
  | 'small-orange'
  | 'big-very-dark';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  animations: [bumpIn],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  @Input() text: string;
  @Input() icon: string;
  @Input() iconDirection: 'left' | 'right';
  @Input() buttonClass: buttonClass;
  @Input() borderClass: string;
  @Input() disabled: boolean;
  @Input() rightTemplate: TemplateRef<any> | null = null;
  @Input() styleInline: { [key: string]: string };
  @Input() buttonId: string;

  @Output() buttonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() down: EventEmitter<any> = new EventEmitter<any>();
  @Output() up: EventEmitter<any> = new EventEmitter<any>();
  @Output() leave: EventEmitter<any> = new EventEmitter<any>();

  buttonState: boolean;

  constructor() {}

  onEvent(value: MouseEvent, event: string): void {
    if (!this.disabled) {
      switch (event) {
        case 'click':
          this.buttonClick.emit(value);
          return;
        case 'up':
          this.up.emit(value);
          return;
        case 'down':
          this.down.emit(value);
          return;
        case 'leave':
          this.leave.emit(value);
          return;
      }
    }
  }
}
